import {useState} from 'react';
import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/layers/main/games_navigation';
import {setGameTab} from '../../../../reducers/user/actions';
import Language from '../../../../language';
import ImageUtil from '../../../../utils/image';

export default () => {
    const {games_tab} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <div className="tabs-container animate__animated animate__fadeIn">
            <div className="tabs">
                <div className={`tab-active ${games_tab}`}></div>

                <div className="tab favorites" onClick={e => dispatch(setGameTab('favorites', games_tab))}>
                    <div className="image">
                        <ImageUtil
                            path={`/images/main/icons/favorites.png`}
                            alt={Language('layers.main.tabs.favorites')} />
                    </div>
                    <div className="tab-name">{Language('layers.main.tabs.favorites')}</div>
                </div>

                <div className="tab fishing"  onClick={e => dispatch(setGameTab('fishing', games_tab))}>
                    <div className="image">
                        <ImageUtil
                            path={`/images/main/icons/fish.png`}
                            alt={Language('layers.main.tabs.fishing')} />
                    </div>
                    <div className="tab-name">{Language('layers.main.tabs.fishing')}</div>
                </div>

                <div className="tab slot"  onClick={e => dispatch(setGameTab('slot', games_tab))}>
                    <div className="image">
                        <ImageUtil
                            path={`/images/main/icons/slot.png`}
                            alt={Language('layers.main.tabs.slot')} />
                    </div>
                    <div className="tab-name">{Language('layers.main.tabs.slot')}</div>
                </div>

                <div className="tab table"  onClick={e => dispatch(setGameTab('table', games_tab))}>
                    <div className="image">
                        <ImageUtil
                            path={`/images/main/icons/table.png`}
                            alt={Language('layers.main.tabs.table')} />
                    </div>
                    <div className="tab-name">{Language('layers.main.tabs.table')}</div>
                </div>
            </div>
        </div>
    )
}